import React from 'react';
import styled from 'styled-components';
import { Header } from '@app/navigation/header';
import { Body } from '@ui';
import { useNavigate } from 'react-router';
import { ROUTES } from '@constants/routes';
import { scrollToTop } from '@utils/usefulFuncs';
import NewQueryTool from '@containers/DigitalAnalyst/NewQueryTool';
import { Body5, Container, Page, SVG_LOADING_ICON_TYPES, SvgLoadingIcon } from '@ui';
import { useColorTheme } from '@hooks';
import BackArrowButton from '@ui/buttons/BackArrowButton';
import { usePreselectedTickers } from '@hooks/features/usePreselectedTickers';
import { usePreselectedDocs } from '@hooks/features/usePreselectedDocs';
import { AI_TOOLS } from '@constants';

const PageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

const tool = AI_TOOLS.QUERY;

function DigitalAnalyst() {
  const colorTheme = useColorTheme();
  const navigate = useNavigate();

  const { complete: preselectedTickersComplete, tickers: preSelectedTickers } = usePreselectedTickers();
  const { complete: completedPreselectDocs, preSelectedDocs } = usePreselectedDocs();

  const onGoBack = () => navigate(ROUTES.home);

  React.useEffect(() => {
    scrollToTop();
  }, []);

  if (!completedPreselectDocs || !preselectedTickersComplete) {
    return (
      <PageWrapper>
        <Header />
        <Body withFooter>
          <Page width={'600px'}>
            <BackArrowButton onClick={onGoBack} />
            <Container top={99} centerAll bottom={99}>
              <SvgLoadingIcon type={SVG_LOADING_ICON_TYPES.bars} color={colorTheme.text} />
              <Container left={8}>
                <Body5>{preselectedTickersComplete ? 'Loading Documents...' : 'Loading...'}</Body5>
              </Container>
            </Container>
          </Page>
        </Body>
      </PageWrapper>
    );
  }

  return (
    <PageWrapper>
      <Header />
      <Body withFooter>
        <NewQueryTool
          onGoBack={onGoBack}
          isQueryMode
          preSelectedTickers={preSelectedTickers}
          preSelectedDocs={preSelectedDocs}
          tool={tool}
        />
      </Body>
    </PageWrapper>
  );
}

export default DigitalAnalyst;
